import React from "react";
import { useTranslation } from "react-i18next";

import { ToggleInput } from "@common/toggleInput";
import { Context } from "../../context";
import { Icon } from "./icon";
import { Props } from "./types";
import styles from "./styles.scss";

function DerivationToggle(_: Props) {
  const { t } = useTranslation();
  const { areDerivationsToggled, toggleDerivations } =
    React.useContext(Context);

  return (
    <div className={styles.delayToggle} onClick={toggleDerivations}>
      <Icon className={styles.icon} />
      <p className={styles.text}>{t("gantt.derivationToggle")}</p>
      <ToggleInput isToggled={areDerivationsToggled} />
    </div>
  );
}

export { DerivationToggle };
